import { FieldMapValue } from '@hb/shared'
import { DataView } from '@components/DataView/DataView'
import { FieldEncounterSection } from '@hb/shared'

export const FieldSectionView = ({
  section,
  data,
}: {
  section: FieldEncounterSection
  data: FieldMapValue
}) => (
  <DataView
    noHeader
    alwaysExpanded
    field={section.field}
    data={data}
    boxProps={{ border: 'none', borderBottom: 'none' }}
  />
)
